{
  "nl": {
    "task": {
      "actions": {
        "create": "Taak",
        "create_and_send": "Aanmaken en versturen",
        "delete": "Taak verwijderen",
        "open_in_project": "Taak openen in project",
        "remove_from_unit": "Taak van deze eenheid verwijderen",
        "save_as_draft": "Opslaan als concept",
        "update": "Taak bewerken"
      },
      "attributes": {
        "assignments_count": "Toewijzingen",
        "category": "Manier van afronden",
        "created_at": "Aangemaakt",
        "description": "Omschrijving",
        "title": "Titel",
        "units": "Eenheden"
      },
      "categories": {
        "confirmation": "Bevestiging",
        "upload": "Document uploaden"
      },
      "categories_info": {
        "confirmation": "De toegewezen persoon vinkt de taak af zodra ze klaar is.",
        "upload": "De toegewezen persoon moet een document uploaden om de taak af te ronden."
      },
      "confirm": {
        "delete_body": "De taak verdwijnt, en elke toewijzing eronder ook: {assignments} over {units}.",
        "delete_header": "\"{title}\" verwijderen?",
        "delete_silent": "Niemand krijgt een melding, en meldingen die al verstuurd zijn worden niet ingetrokken.",
        "remove_from_unit_body": "Elke toegewezene van \"{title}\" op {unit} verliest ze. De taak zelf en haar andere eenheden blijven zoals ze zijn.",
        "remove_from_unit_customers": "De klanten van {unit} zien ze niet meer in hun portaal.",
        "remove_from_unit_header": "Deze taak van {unit} verwijderen?"
      },
      "filters": {
        "phase_none": "Geen fase"
      },
      "labels": {
        "assignments_count": "{count} toewijzing | {count} toewijzingen",
        "created_by": "Aangemaakt door {name} · {date}",
        "created_on": "Aangemaakt op {date}",
        "no_tasks": "Nog geen taken voor dit project.",
        "required": "Dit veld is verplicht",
        "set_all_assignees": "De toegewezene instellen | Alle {count} toegewezenen instellen",
        "still_to_do": "nog {count} te doen",
        "units_count": "{count} eenheid | {count} eenheden",
        "units_required": "Selecteer minstens één eenheid"
      },
      "toasts": {
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "remove_from_unit": "Taak van deze eenheid verwijderd",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
